import { v4, validate } from 'uuid';

/**
 * Generates a cryptographically secure v4 UUID
 * @returns A valid v4 UUID string
 */
function uuidv4(): string {
  return v4();
}

const isUuidString = (id: number | string): id is string => typeof id === 'string' && validate(id);

export { uuidv4, isUuidString };
